/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';

import * as S from './styles';

const LoadingError = (): JSX.Element | null => {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Title align="center">{t('core.oops')}</S.Title>
      <S.Description className="bold">{t('core.error_occured')}</S.Description>
      <S.Description>{t('core.try_again_or_contact_admin')}</S.Description>
    </S.Container>
  );
};

export default LoadingError;
